import { FC, useEffect } from "react";
import { Outlet } from "react-router";
import { isMobile } from "react-device-detect";
import AboutNavigation from "./components/AboutNavigation";
import { Helmet } from "react-helmet-async";
import aboutPageStore from "./store/aboutPageStore";
import { observer } from "mobx-react-lite";

export const renderStringToHTML = (str: string) => {
  return <div dangerouslySetInnerHTML={{ __html: str }} />;
};

const AboutPage: FC = () => {
  useEffect(() => {
    aboutPageStore.fetchSections();
  }, []);

  return (
    <div className={`flex ${isMobile ? "flex-col p-2" : "flex-row p-4 gap-4"}`}>
      <Helmet>
        <>
          <title>КЦ Авто | О нас</title>
          <meta
            name="description"
            content={`КЦ авто о компании о нас политика конфилициальности купить автозапчасти Корея центр`}
          />
          <meta
            name="keywords"
            content="КЦ Авто, интернет магазин автозапчастей, поиск запчастей, купить автозапчасти, о компании, о нас, политика конфилициальности, доставка и оплата"
          />
        </>
      </Helmet>
      <AboutNavigation />
      <div className={`${isMobile ? "px-2" : ""} flex-1`}>
        <Outlet />
      </div>
    </div>
  );
};

export default observer(AboutPage);
